namespace advisorop.components.advisor {
    
    export class AdvisorDashboardController{
        $router;
        numOfHoldingRecords: number = 25;
        public topWhat: number = 1;
        public chartMarketValueHistory: domains.IChartDataSource;
        public n: string = "10";
        public startValueChangeDate: Date = new Date();
        public currValueChangeDate: Date = new Date();
        public investorLoginsFromDate: Date = new Date();
        public investorLoginsToDate: Date = new Date();
        public selectFilterSecurityCodeCtl: advisorop.components.common.SelectFilterSecurityCodeController;
        showUserEntry: boolean = true;
        AcctValuesIssuesCount: number;
        public topSecOrModel: number = 1;
        public topN: string = "10";
        public aumType: string = "0";
        adminMode;
        adminModeEnabled: boolean = false;
        public dgAdvisorAUM;
        public advisorAUM: domains.IChartDataSource;

        constructor(private advisorService: services.AdvisorService, private $rootScope: ng.IRootScopeService,
            private $window: any) {

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.aumType = "0";   // reset to growth history
                this.loadMarketValue();
            }); 

            this.chartMarketValueHistory = {
                chart: {
                    caption: "", numberPrefix: "", subCaption: "", theme: "" },
                data: []
            };

            this.dgAdvisorAUM = {
                export: {
                    enabled: true,
                    fileName: "AdvisorAUM"
                },
                bindingOptions: {
                    dataSource: "vm.advisorAUM.data"
                },
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                columns: [
                    { dataField: 'label', caption: 'Advisor' },
                    { dataField: 'value', caption: 'USD Value', width: 110, format: { type: 'fixedPoint', precision: 2 }, sortIndex: '0', sortOrder: 'desc' }
                ],
            };
        }
        
        loadMarketValue() {
            this.adminMode = this.advisorService.getAdminMode();
            this.adminModeEnabled = this.adminMode && this.adminMode.enabled;
            this.advisorService.getMarketValueByPrimaryAdvisor(this.adminModeEnabled, this.adminModeEnabled ? this.adminMode.advisoryFirm.id : null)
                .then((data) => {
                    //console.log("THE DATA IS", data);

                    this.chartMarketValueHistory = data.data[0];
                    if (this.chartMarketValueHistory && this.chartMarketValueHistory.data?.length > 0) {
                        this.chartMarketValueHistory.data.forEach(x => {
                            x.value = Math.round(x.value / 1000000 * 1e1) / 1e1
                        });
                    }

                    this.chartMarketValueHistory.chart.outCnvBaseFontSize = "12";
                    this.chartMarketValueHistory.chart.showValues = "1";
                    this.chartMarketValueHistory.chart.valueFontSize = "14";
                    this.chartMarketValueHistory.chart.numberPrefix = "";
                    this.chartMarketValueHistory.chart.yAxisName = "AUM ($ Millions)";
                    //this.chartMarketValueHistory.chart.valuePadding = "-25";
                    //this.chartMarketValueHistory.chart.yAxisValuesStep = "1";
                    //this.chartMarketValueHistory.chart.rotateValues = "0";
                    //this.chartMarketValueHistory.chart.yAxisName = "AUM ($ Millions)";
                    //this.chartMarketValueHistory.chart.subCaption = "$ Millions";
                    //this.chartMarketValueHistory.chart.placevaluesInside = "1";

                    //if (this.chartMarketValueHistory.data && this.chartMarketValueHistory.data.length > 0)
                    //    this.chartMarketValueHistory.data[this.chartMarketValueHistory.data.length - 1].showValue = "1";

                    if (this.adminModeEnabled) {
                        var chartMarketValueByAdvisor = data.data[1];

                        //if (chartMarketValueByAdvisor && chartMarketValueByAdvisor.data?.length > 0) {
                        //    chartMarketValueByAdvisor.data.forEach(x => {
                        //        x.value = Math.round(x.value / 1000000 * 1e1) / 1e1
                        //    });
                        //}
                        this.advisorAUM = chartMarketValueByAdvisor;
                    }

                }).catch((response) => {
                    toastr.error("AUM Growth Summary error: " + response.status + ":" + response.data);
                });
        }

        onSelectFilterSecurityCodeReady(ctrl) {
            this.selectFilterSecurityCodeCtl = ctrl;
        }

        $onInit(): void {
            this.investorLoginsFromDate.setDate(this.investorLoginsToDate.getDate() - 14);
            this.loadMarketValue();
        };

        $routerOnActivate(next, previous) {
            
        }; 

        //init() {
        //    console.log('Loading Viewer view');

        //    console.log('Creating the report viewer with default options');
        //    var viewer = new this.$window.Stimulsoft.Viewer.StiViewer(null, 'StiViewer', false);

        //    console.log('Creating a new report instance');
        //    var report = new this.$window.Stimulsoft.Report.StiReport();

        //    console.log('Load report from url');
        //    report.loadFile('/reports/SimpleList.mrt');

        //    console.log('Assigning report to the viewer, the report will be built automatically after rendering the viewer');
        //    viewer.report = report;

        //    console.log('Rendering the viewer to selected element');
        //    viewer.renderHtml('viewer');

        //    console.log('Loading completed successfully!');
        //}

    }



    class AdvisorDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ["advisorService", "$rootScope", "$window", AdvisorDashboardController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/advisor-dashboard.html';            
        }
    }
    angular.module(Constants.APP).component("advisorDashboard", new AdvisorDashboard());
    
}